import React, {useEffect, useState} from 'react'
import ModalEnabled from '../../../components/modalComponents/ModalEnabled';
import PageHeader from '../../../components/pageHeader/PageHeader';
import SearchContainer from '../../../components/pageComponents/SearchContainer';
import PageButtons from '../../../components/pageComponents/PageButtons';
import {NavDropdown} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import {useManagePostRequest} from '../../../hooks/useManagePostRequest/useManagePostRequest';
import {
    DescargarReporteSolicitudesBeneficiosAPI,
    getAllAreasAPI, getAllCampanasAPI,
    getAllCargosAPI,
    getAllEstadosAPI, getAllSedesAPI,
    getListaSolicitudesBeneficiosAPI
} from '../../../consumers/backendApisUrls';
import styled from "styled-components";
import TableSolicitudesBeneficios from "./TableSolicitudesBeneficios";
import {useGetRequest} from "../../../hooks/useGetRequest/useGetRequest";
import {
    initialAllOptionPromises,
    isNullOrUndefinded,
    jsonNoEstaVacio,
    updateFiltersWithExtraData
} from "../../../helper/utils";
import PageWrapper from "../../../components/pageComponents/PageWrapper";
import {useManageGetRequest} from "../../../hooks/useManageGetRequest/useManageGetRequest";
import useDidMountEffect from "../../../hooks/useDidMountEffect/useDidMountEffect";
import Select from "react-select";
import {
    useGenerarDescargarEliminarArchivo
} from "../../../hooks/useGenerarDescargarEliminarArchivo/useGenerarDescargarEliminarArchivo";

const INIT_KEYS = {
    IdsCargos: "IdsCargos",
    IdsAreas: "IdsAreas",
    IdsSedes: "IdsSedes",
    IdsEstadosSolicitud: "IdsEstadosSolicitud"
};

const AdminGestionDeBeneficios = () => {
    const [formValues, setFormValues] = useState({Items: [], ExtraData: {}, filters: [], selectedFilters: {}});
    const [allFilters, setAllFilters] = useState([]);

    const [searchCriteria, setSearchCriteria] = useState("");
    const [paginator, setPaginator] = useState({CurrentPage: 1});
    const [isLoading, setIsLoading] = useState(true);

    const [modalEnabled, setModalEnabled] = useState({isEnable: false, component: React.Fragment});

    const [executeGet] = useGetRequest();
    const [executeManagePost] = useManagePostRequest();
    const [executeManageGet] = useManageGetRequest();

    const [allCampanas, setAllCampanas] = useState([]);
    const [selectedCampana, setSelectedCampana] = useState({});

    const [downloaAndDeletedReport] = useGenerarDescargarEliminarArchivo();

    const initialPromises = () => {
        const response = executeGet(getAllEstadosAPI());

        return [
            executeGet(getAllCargosAPI()),
            executeGet(getAllAreasAPI()),
            executeGet(getAllSedesAPI()),
            response
        ];
    }

    const init = async () => {
        setIsLoading(true);
        try {
            await getAllCampanas();
            await initialAllOptionPromises(initialPromises, Object.values(INIT_KEYS), setAllFilters);
            await manageSearch();
            if (formValues.filters.length === 0) {
                jsonNoEstaVacio(formValues.ExtraData) &&
                updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    const manageSearch = async () => {
        if (!isNullOrUndefinded(selectedCampana?.value)) {
            setIsLoading(true);
            const api = getListaSolicitudesBeneficiosAPI();
            const payload = getPayload();
            await executeManagePost(api, payload, successManageSearchCallback);
            setIsLoading(false);
        }
    }

    const getPayload = () => {
        return {
            Criteria: searchCriteria,
            Page: paginator.CurrentPage,
            IdsCampanasBeneficio: [selectedCampana?.value],
            ...formValues.selectedFilters
        }
    }

    const getAllCampanas = async () => {
        const api = getAllCampanasAPI();
        await executeManageGet(api, (res) => successGetAllCampanasCallback(res), false);
    }

    const successGetAllCampanasCallback = ({data}) => {
        const items = data.map(o => ({value: o.Value, label: o.Text}));
        setAllCampanas(items);
        if (items.length > 0)
            setSelectedCampana(items[0])
    }

    const successManageSearchCallback = ({data}) => {
        const {Items, ExtraData, TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage} = data;
        setFormValues(lastData => ({...lastData, Items, ExtraData}));
        setPaginator({TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage});
    }

    const handleUpdatedFilters = (res) => {
        setFormValues(lastData => ({...lastData, filters: res}))
    }

    const handleCleanSearch = () => {
        setFormValues({...formValues, selectedFilters: null});
    }

    useDidMountEffect(() => {
        manageSearch();
    }, [paginator.CurrentPage, formValues.selectedFilters, selectedCampana])

    useDidMountEffect(() => {
        jsonNoEstaVacio(formValues.ExtraData) && updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
    }, [formValues.ExtraData])

    useEffect(() => {
        init();
    }, [])

    const handleDescargar = async () => {
        const api = DescargarReporteSolicitudesBeneficiosAPI();
        const payload = getPayload();
        await downloaAndDeletedReport(api, payload);
    }

    return (

        <PageWrapper isLoading={isLoading}>
            <ModalEnabled
                modalEnabled={modalEnabled}
                setModalEnabled={setModalEnabled}
                refreshPage={manageSearch}
            />
            <PageHeader title="Gestión de Solicitudes de Beneficios"/>

            <SelectCampana items={allCampanas} selectedItem={selectedCampana} setSelectedItem={setSelectedCampana}/>

            <SearchContainer
                searchCriteria={searchCriteria}
                setSearchCriteria={setSearchCriteria}
                setPaginator={setPaginator}
                manageSearch={manageSearch}
                addCleanSearch={handleCleanSearch}>
                <ButtonsWrapper>
                    <PageButtons>
                        <NavDropdown id={"navDropdown-admiGestionDeBeneficios"}
                                     className="generic-button-dropdown font-gothan-light"
                                     title={
                                         <span className="generic-button-dropdown-title">Acciones</span>
                                     }>
                            <Link
                                to="gestionDeBeneficios/listaDeCampañas"
                                className="dropdown-item">
                                Lista Campañas
                            </Link>
                            <Link
                                to="gestionDeBeneficios/listaDeItems"
                                className="dropdown-item">
                                Lista Items
                            </Link>
                            <NavDropdown.Item onClick={handleDescargar}>Descargar</NavDropdown.Item>
                        </NavDropdown>
                    </PageButtons>
                </ButtonsWrapper>
            </SearchContainer>

            <TableSolicitudesBeneficios
                formValues={formValues}
                setFormValues={setFormValues}
                extraData={formValues.ExtraData}
                setModalEnabled={setModalEnabled}
                paginator={paginator}
                setPaginator={setPaginator}
                keys={INIT_KEYS}
                isAdmin={true}
            />
        </PageWrapper>

    );
};

export default AdminGestionDeBeneficios;

const SelectCampana = ({items, selectedItem, setSelectedItem}) => (
    <div className='col-sm-4 mt-2 ml-2'>
        <Select
            options={items}
            value={selectedItem}
            onChange={(res) => setSelectedItem({...res})}
            placeholder="Seleccionar campaña"
        />
    </div>
)

const ButtonsWrapper = styled.div`
    display: block;
    @media (max-width: 796px) {
        display: none;
    }
`;
